import * as Actions from '../../../Modules/CmsActions'

const initialState = {
  loading: false,
  saving: false,
  edit: {
    name: '',
    display_name: '',
    template_type_key: '',
    taxonomies: [],
  },
}

const UIPostTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.REQUEST_FETCH_POST_TYPE:
      return { ...state, loading: true }

    case Actions.REQUEST_CREATE_POST_TYPE:
    case Actions.REQUEST_UPDATE_POST_TYPE:
      return { ...state, saving: true }

    case Actions.FINISH_FETCH_POST_TYPE:
      return { ...state, loading: false, edit: action.payload.postType }

    case Actions.FINISH_CREATE_POST_TYPE:
    case Actions.FINISH_UPDATE_POST_TYPE:
      return { ...state, saving: false }

    case Actions.FAILURE_FETCH_POST_TYPE:
    case Actions.FAILURE_CREATE_POST_TYPE:
    case Actions.FAILURE_UPDATE_POST_TYPE:
      return { ...state, saving: false }

    default:
      return state
  }
}

export default UIPostTypeReducer
